import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/bg-login-asesi.svg'


const _hoisted_1 = { class: "l-auth flex overflow-hidden w-screen h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "l-auth__logo justify-center w-3/5 hidden md:flex",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "l-auth__background",
    src: _imports_0,
    alt: "",
    role: "presentation"
  })
], -1)
const _hoisted_3 = {
  class: "l-auth__form flex justify-center items-center py-12 px-10 w-full md:w-2/5",
  role: "main"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TemplatesLogin = _resolveComponent("TemplatesLogin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("main", _hoisted_3, [
      _createVNode(_component_TemplatesLogin, _mergeProps(_ctx.config, {
        "form-data": _ctx.formData,
        onSubmit: _ctx.submitLogin
      }), null, 16, ["form-data", "onSubmit"])
    ])
  ]))
}